<template>
  <RevContentBlock
    :image-left="false"
    :image-props="emptyImageProps"
    :surtitle
    :title
    title-tag="h2"
    title-variant="title1"
  >
    <p class="body-1">
      {{ description }}
    </p>
  </RevContentBlock>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevContentBlock } from '@ds/components/ContentBlock'

const props = defineProps<{
  title: string
  surtitle: string
  description: string
}>()

const emptyImageProps = computed(() => ({
  alt: props.title,
  src: '/img/empty.svg',
  height: 300,
  width: 600,
}))
</script>
